import { convertToRaw } from 'draft-js';
export var PARSE_RESULT_TYPE;
(function (PARSE_RESULT_TYPE) {
    PARSE_RESULT_TYPE["HTML"] = "html";
    PARSE_RESULT_TYPE["TEXT"] = "text";
})(PARSE_RESULT_TYPE || (PARSE_RESULT_TYPE = {}));
export const parseText = (text, suggestions, returnType) => {
    const t = convertToDomElement(text);
    for (let i = 0; i < suggestions.length; i++) {
        const suggestion = suggestions[i];
        const mentions = t.querySelectorAll(`a[data-value='${suggestion.label}']`);
        mentions.forEach((mention) => {
            const replaceValue = mention.innerHTML.replace(new RegExp(`@${suggestion.label}`), suggestion.field);
            mention.outerHTML = replaceValue;
        });
    }
    if (returnType === 'text') {
        return t.innerText;
    }
    return t.innerHTML;
};
/**
 * Converts template tags like `{{creditor.name}}` into `@Creditor Name`
 * @param text
 */
export const encodeText = (text, suggestions) => {
    let t = text;
    for (let i = 0; i < suggestions.length; i++) {
        const suggestion = suggestions[i];
        const re = new RegExp(suggestion.field, 'g');
        t = t.replace(re, stringBuilderToParser(suggestion.label));
    }
    return t;
};
const replaceHtmlEntites = (() => {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
        nbsp: String.fromCharCode(160),
        amp: '&',
        quot: '"',
        lt: '<',
        gt: '>',
    };
    const translator = (full, match) => {
        return translate[match];
    };
    return (s) => {
        return s.replace(translate_re, translator);
    };
})();
export const getSubjectContent = (subjectHtml) => {
    const regex = new RegExp(`(<p>){1}(.*)(<\/p>){1}`, 'g');
    const matches = regex.exec(subjectHtml);
    return replaceHtmlEntites((matches && matches[2]) || subjectHtml);
};
const stringBuilderToParser = (label) => {
    return `<a href="${label}" class="wysiwyg-mention" data-mention data-value="${label}">@${label}</a>`;
};
const convertToDomElement = (htmlString) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = htmlString;
    return wrapper;
};
export const templateValidator = (editorState, lang) => {
    const errors = [];
    const raw = convertToRaw(editorState.getCurrentContent());
    let ifCounter = 0;
    let endIfCounter = 0;
    let orderCounter = 0;
    Object.values(raw.entityMap).forEach((entity) => {
        if (entity.type === 'MENTION') {
            const key = entity.data.text;
            if ('@' + lang.mentionsConditional.if === key.split(' ')[0]) {
                ifCounter++;
                orderCounter++;
            }
            else if ('@' + lang.mentionsConditional.endIf === key) {
                endIfCounter++;
                if (orderCounter > 0) {
                    orderCounter--;
                }
            }
        }
    });
    if (ifCounter > endIfCounter) {
        errors.push({
            message: lang.templates.validations.missing +
                ' @' +
                lang.mentionsConditional.endIf,
            count: ifCounter - endIfCounter,
        });
    }
    else if (ifCounter < endIfCounter) {
        errors.push({
            message: lang.templates.validations.missing + ' @' + lang.mentionsConditional.if,
            count: endIfCounter - ifCounter,
        });
    }
    if (orderCounter > 0) {
        errors.push({
            message: lang.templates.validations.invalidOrder,
            count: orderCounter,
        });
    }
    return errors;
};
//# sourceMappingURL=templates.js.map